import moment from 'moment';

const MEPTags = (doc, data, clinica) => {
    var MEP = doc.createElement("MEP");

    //Medio de Pago
    var MEP_1 = doc.createElement("MEP_1");
    MEP_1.innerHTML = data.facturado.medio_pago;
    MEP.appendChild(MEP_1);

    //Metodo de Pago (1-Contado, 2-Credito)
    var MEP_2 = doc.createElement("MEP_2");
    MEP_2.innerHTML = data.facturado.tipo_negociacion;
    MEP.appendChild(MEP_2);

    //Fecha de Vencimiento de la Factura
    var MEP_3 = doc.createElement("MEP_3");
    MEP_3.innerHTML = moment(data.fecha_vencimiento).format("YYYY-MM-DD");
    MEP.appendChild(MEP_3);

    return MEP;
}

export default MEPTags;